import axios from 'axios'
import { deepFreeze } from '../../../features/common/Utilities'
import { SAVINGS_PLAN_ENDPOINT } from 'cfgCommon/endpoints'

export async function getSavingsPlanListVistaVendedor({ search, cancelToken }) {
  const results = await axios
    .get(`${SAVINGS_PLAN_ENDPOINT}${search}&published=true`, {
      cancelToken,
    })
    .then(res => res.data)
    .then(res => {
     return res
    })

  return deepFreeze(results)
}
